import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { AUTH, SECURITY, GET_JOBPACKS, GET_USERS, GET_GROUPS } from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { push } from "connected-react-router";
export var checkAuth = function checkAuth() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: AUTH.REQUEST
              });
              firebase.auth().onAuthStateChanged(function (user) {
                if (user === null) {
                  dispatch({
                    type: AUTH.FAIL
                  });
                  dispatch(push("/login"));
                } else {
                  firebase.database().ref("/users/".concat(user.uid, "/profile")).on("value", function (snapshot) {
                    dispatch({
                      type: AUTH.SUCCESS,
                      payload: snapshot.val()
                    });
                  });
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getUsers = function getUsers() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("hjgfhjgdfyhjt");
              dispatch({
                type: GET_USERS.REQUEST
              });
              firebase.auth().onAuthStateChanged(function (user) {
                if (user === null) {
                  dispatch({
                    type: GET_USERS.FAIL
                  });
                  dispatch(push("/login"));
                } else {
                  firebase.database().ref("/users").on("value", function (snapshot) {
                    dispatch({
                      type: GET_USERS.SUCCESS,
                      payload: snapshot.val()
                    });
                  });
                }
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getJobPacks = function getJobPacks() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: GET_JOBPACKS.REQUEST
              });
              firebase.auth().onAuthStateChanged(function (user) {
                if (user === null) {
                  dispatch({
                    type: GET_JOBPACKS.FAIL
                  });
                  dispatch(push("/login"));
                } else {
                  firebase.database().ref("/subjects/jobpacks").on("value", function (snapshot) {
                    dispatch({
                      type: GET_JOBPACKS.SUCCESS,
                      payload: snapshot.val()
                    });
                  });
                }
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getGroups = function getGroups() {
  return function (dispatch) {
    dispatch({
      type: GET_GROUPS.REQUEST
    });

    try {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user === null) {
          dispatch({
            type: GET_GROUPS.FAIL
          });
        } else {
          firebase.database().ref("/subjects/message_groups").on("value", function (snapshot) {
            dispatch({
              type: GET_GROUPS.SUCCESS,
              payload: snapshot.val()
            });
          });
        }
      });
    } catch (e) {
      dispatch({
        type: GET_GROUPS.FAIL
      });
    }
  };
};
export var getConfig = function getConfig() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch({
                type: SECURITY.REQUEST
              });
              firebase.auth().onAuthStateChanged(function (user) {
                if (user === null) {
                  dispatch({
                    type: SECURITY.FAIL
                  });
                  dispatch(push("/login"));
                } else {
                  firebase.database().ref("/collections/level_permissions").on("value", function (snapshot) {
                    dispatch({
                      type: SECURITY.SUCCESS,
                      payload: snapshot.val()
                    });
                  });
                }
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};